import { Component, Input } from '@angular/core';
import { AnalyticsService } from '../../../../../../../services/analytics.service';

@Component({
    selector: 'app-slider-label',
    templateUrl: './slider-label.component.html',
    styleUrls: ['./slider-label.component.scss'],
    standalone: false
})

export class SliderLabelComponent {

  @Input() left: string;
  @Input() right: string;
  @Input() disableAddPlus: boolean = false;

}
